<template lang="pug">
// AVAILABLE PAGE TEMPLATES:
// - TODO
// AVAILABLE SECTION TEMPLATES:
// - content-slider (optional images & link)
// - collection-grid (textual + optional images & link) / collection-grid-img (img only)
// - collection-list (optional images & link)
// - textblock-img-left / textblock-img-right / textblock-img-alternate
// - pagefooter
// - article

div.main(:class="`${this.template} ${this.name}`")
  navigation
  div.page
    section#opening.row
      //- div.hero
        //- <img :src='null' alt='' />

      .page-header
        h1
          vue-markdown(:source='this.title')
        div.desc
          vue-markdown(:source='this.desc')

    section(v-for="(n, i) in this.sections" class="row")
      component(:is="kebabToCamel(n.fields.templateId)" :payload="n")
</template>

<script>
import pageBase from '@/scenes/_pageBase.js'

// import { kebabToCamel } from '@/helpers'

export default {
  name: 'defaultScene',
  mixins: [pageBase],
  components: {},
  methods: {
  },
  mounted () {
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/scenes/defaultScene.vue